<template>
  <v-app>
    <HeaderSimple />
    <v-container class="fill-height align-start">
      <v-snackbar v-model="snackbar" :color="resultSnack" :timeout="3000">
        {{ msg }}
        <v-btn dark text @click="snackbar = false">
          Close
        </v-btn>
      </v-snackbar>
      <v-row class="align-center justify-center">
        <v-col class="col-12">
          <v-form v-model="valid" ref="form">
            <v-container>
              <v-row class="justify-center">
                <v-col class="col-12 col-sm-6 col-md-5">
                  <v-text-field
                    solo
                    flat
                    label="Senha Antiga"
                    v-model="old_password"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :rules="obligatoryRules"
                    required
                    background-color="#F7F7F7"
                  ></v-text-field>
                  <v-text-field
                    solo
                    flat
                    label="Nova Senha"
                    v-model="new_password"
                    :append-icon="show2 ? 'visibility' : 'visibility_off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                    :rules="passwordRules"
                    required
                    background-color="#F7F7F7"
                  ></v-text-field>
                  <v-text-field
                    solo
                    flat
                    :label="$t('pageCadastro.labelConfirmPassword')"
                    v-model="new_password_confirmation"
                    :append-icon="show3 ? 'visibility' : 'visibility_off'"
                    :type="show3 ? 'text' : 'password'"
                    @click:append="show3 = !show3"
                    :rules="senhaConfirmationRules"
                    required
                    background-color="#F7F7F7"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="flex-column align-center justify-center">
                <v-btn
                  class="mb-4"
                  color="secondary"
                  depressed
                  large
                  @click="submit"
                  :disabled="!valid"
                  :loading="loader"
                >
                  CONTINUAR
                </v-btn>
                <v-btn text @click="back">Cancelar</v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import HeaderSimple from '@/components/HeaderSimple';
import Api from '../services/httpClient';

export default {
  components: {
    HeaderSimple,
  },
  data: () => ({
    valid: false,
    show1: false,
    show2: false,
    show3: false,
    loader: false,
    cod: '',
    email: '',
    old_password: '',
    new_password: '',
    new_password_confirmation: '',
    msg: '',
    snackbar: false,
    resultSnack: '',
    obligatoryRules: [v => !!v || 'A senha é obrigatória'],
    passwordRules: [
      v => !!v || 'A senha é obrigatória',
      v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v)
        || 'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
    ],
  }),

  async created() {
    await this.getCod();
    this.getUsername();
  },

  computed: {
    senhaConfirmationRules() {
      return [
        v => !!v || 'A senha é obrigatória',
        () => this.new_password === this.new_password_confirmation
          || 'A Senha não corresponde com a informada anteriormente.',
        v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$/.test(v)
          || 'A senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula e número.',
      ];
    },
  },

  methods: {
    back() {
      history.back();
    },
    submit() {
      this.loader = true;

      Api.post('/users/change_password/', {
        username: this.email,
        old_password: this.old_password,
        new_password: this.new_password,
        new_password_confirmation: this.new_password_confirmation,
      })
        .then(response => {
          this.valid = false;
          this.msg = 'Senha alterada com sucesso!';
          this.resultSnack = 'success';
          this.snackbar = true;
          setTimeout(() => {
            this.snackbar = false;
            localStorage.clear();
            if (localStorage.getItem('user-category') === 'patient') {
              this.$router.replace('/paciente/login');
            } else {
              this.$router.replace('/psicologo/login');
            }
          }, 3000);
        })
        .catch(err => {
          this.msg = err.response.data[0];
          this.snackbar = true;
        })
        .finally((this.loader = false));
    },

    async getUsername() {
      const user = await JSON.parse(localStorage.getItem('user-data'));
      this.email = user.email;
    },

    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
  },
};
</script>
